import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const Pin2SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 11}
    height={props.height ? props.height : 11}
    fill="none"
    {...props}
  >
    <mask id="a" fill="#fff">
      <path d="M.117.117h5.372v10.255H.117V.117Z" />
    </mask>
    <path fill="#878787" d="M5 .117v10.255h.977V.117H5Z" mask="url(#a)" />
    <mask id="b" fill="#fff">
      <path d="M.117.117h10.255v5.371H.117V.117Z" />
    </mask>
    <path fill="#878787" d="M10.372 5H.117v.977h10.255V5Z" mask="url(#b)" />
  </svg>
)
export default Pin2SVG
